<template>
  <div>
    <v-card class="pb-4">
      <!-- @mouseover="drawer=true" -->
      <!-- :mini-variant="!isMobile && drawer" -->
      <!-- <v-navigation-drawer 
        :expand-on-hover="!isMobile"
        :temporary="isMobile"
        :fixed="isMobile"
        :permanent="!isMobile"
        v-model="drawer"
        app
        width="350"
        dense
        > -->

      <!-- :mini-variant="mini" -->
      <!-- <v-navigation-drawer v-if="$store.getters.isAuthen"
        v-model="drawer"
        :hide-overlay="true"
        :clipped="false"
        :absolute="false"
        :expand-on-hover="false"
        :permanent="!isMobile"
        :fixed="true"
        app
        width="350"
        > -->
      <!-- v-model="drawer" -->
      <v-navigation-drawer
        v-if="$store.getters.isAuthen"
        app
        v-model="drawer"
        :mini-variant="mini"
        :expand-on-hover="!menuPin && !isMobile"
        :permanent="!isMobile"
        width="350"
      >
        <v-list>
          <v-list-item class="px-2" link>
            <v-list-item-avatar @click="toggleMenu">
              <img
                :src="
                  apiPath +
                  'content/emp_img.asp?w=450&img=' +
                  $store.state.users.main.Description +
                  '.jpg'
                "
              />
            </v-list-item-avatar>
            <v-list-item-content @click="$router.push('/profile')">
              <v-list-item-title class="title">
                {{ $store.state.users.main.FullName }}
              </v-list-item-title>
              <v-list-item-subtitle>
                {{ $store.state.users.main.EmailAddress }}
              </v-list-item-subtitle>
            </v-list-item-content>
            <v-btn icon @click="pinMenu">
              <v-icon small v-if="!menuPin">mdi-pin-off</v-icon>
              <v-icon small v-else>mdi-pin</v-icon>
            </v-btn>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list dense nav>
          <v-list-item link :to="'/'" @click="layoutRefresh">
            <v-list-item-icon @click="toggleMenu">
              <v-icon>home</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>หน้าแรก</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-group v-model="selectedPR" prepend-icon1="mdi-cart">
            <template v-slot:activator>
              <!-- <router-link :to="'/pr/prdochdList'"> -->
              <v-list-item-icon @click="mini = false">
                <v-badge color="red" dot v-if="prListCountAll > 0">
                  <v-icon>store</v-icon>
                </v-badge>
                <v-icon v-if="!(prListCountAll > 0)">store</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>ใบขอซื้อ/ขอจ้าง</v-list-item-title>
              </v-list-item-content>

              <!-- </router-link> -->
            </template>
            <v-divider></v-divider>
            <v-list-item
              link
              v-for="item in menuPR"
              :key="item.title"
              :to="item.to"
            >
              <v-list-item-icon @mouseover1="drawer = false">
                <v-badge color="red" dot v-if="prListCount[item.nfloat] > 0">
                  <v-icon>{{ item.icon }}</v-icon>
                </v-badge>
                <v-icon v-if="!(prListCount[item.nfloat] > 0)">{{
                  item.icon
                }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
                <v-list-item-subtitle>{{ item.subt }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon @mouseover1="drawer = false">
                <v-badge
                  color="red"
                  :content="prListCount[item.nfloat]"
                  inline
                  class="caption"
                  v-if="prListCount[item.nfloat] > 0"
                >
                </v-badge>
              </v-list-item-icon>
            </v-list-item>
            <v-divider></v-divider>
            <v-list-item
              link
              v-for="item in menuPRAS"
              :key="item.title"
              :to="item.to"
            >
              <v-list-item-icon @mouseover1="mini = false">
                <v-badge color="red" dot v-if="prListCount[item.nfloat] > 0">
                  <v-icon>{{ item.icon }}</v-icon>
                </v-badge>
                <v-icon v-if="!(prListCount[item.nfloat] > 0)">{{
                  item.icon
                }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
                <v-list-item-subtitle>{{ item.subt }}</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-icon @mouseover1="drawer = false">
                <v-badge
                  color="red"
                  :content="prListCount[item.nfloat]"
                  inline
                  class="caption"
                  v-if="prListCount[item.nfloat] > 0"
                >
                </v-badge>
              </v-list-item-icon>
            </v-list-item>
            <v-divider></v-divider>
          </v-list-group>

          <v-list-group v-model="selectedSaraban">
            <template v-slot:activator>
              <v-list-item-icon @click="mini = false">
                <v-icon>mdi-file-document-multiple</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>ระบบงานสารบรรณ</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              link
              v-for="item in menuleft"
              :key="item.title"
              :to="item.to"
            >
              <v-list-item-icon @mouseover1="drawer = false">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-circle-small</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-group>

          <v-list-group v-model="selectedCarRoom">
            <template v-slot:activator>
              <v-list-item-icon @click="mini = false">
                <v-icon>mdi-domain</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>ระบบการจอง</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              link
              v-for="item in menuCarRoom"
              :key="item.title"
              :to="item.to"
            >
              <v-list-item-icon @mouseover1="drawer = false">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-circle-small</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-group>

          <v-list-group v-model="selectedQuotation">
            <template v-slot:activator>
              <v-list-item-icon @click="mini = false">
                <v-icon>widgets</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>ใบเสนอราคา</v-list-item-title>
              </v-list-item-content>
            </template>
            <v-list-item
              link
              v-for="item in menuleftQuatation"
              :key="item.title"
              :to="item.to"
            >
              <v-list-item-icon @mouseover1="drawer = false">
                <v-icon>{{ item.icon }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title v-text="item.title"></v-list-item-title>
              </v-list-item-content>
              <v-list-item-icon>
                <v-icon>mdi-circle-small</v-icon>
              </v-list-item-icon>
            </v-list-item>
          </v-list-group>
        </v-list>
      </v-navigation-drawer>

      <v-app-bar dense app clipped-left1 color="indigo" dark fixed1>
        <v-app-bar-nav-icon
          @click="
            drawer = !drawer;
            mini = false;
          "
          class="hidden-sm-and-up"
        />
        <span
          style="cursor: pointer;"
          @click="navigateTo({ name: '/' })"
          class="title ml-3 mr-5"
          >TAI&nbsp;
          <span v-if="env === 'production'" class="font-weight-light"
            >Intranet</span
          >
          <span v-else> {{ env }} </span>
        </span>
        <v-text-field
          v-if="false"
          solo-inverted
          flat
          hide-details
          label="Search"
          prepend-inner-icon="search"
        />
        <v-spacer />
        <v-menu
          offset-y
          :close-on-content-click="false"
          :nudge-width="200"
          v-model="menu"
        >
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-badge color="cyan" overlap v-if="$store.getters.isAuthen">
                <span slot="badge">{{
                  $store.state.users.notificate.length
                }}</span>
                <v-icon>notifications</v-icon>
              </v-badge>
            </v-btn>
          </template>
          <v-card>
            <v-list>
              <v-list-item
                v-for="item in $store.state.users.notificate"
                :key="'noti' + item.ID + item.EmpCode"
                :filter="
                  'EmpCode = \'' + $store.state.users.main.empCode + '\''
                "
                @click.stop="DelNoti(item)"
              >
                <v-list-item-avatar>
                  <!-- <v-avatar class="info">{{item.App}}</v-avatar> -->
                  <v-avatar size="55px">
                    <img
                      :src="
                        staticPath + 'doc-images/cards/' + item.App + '.jpg'
                      "
                      :alt="item.EmpCode"
                    />
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title v-text="item.Title"></v-list-item-title>
                  <v-list-item-subtitle>{{
                    item.insertDate | datetime
                  }}</v-list-item-subtitle>
                  <v-list-item-subtitle>{{
                    item.insertDate | datedif
                  }}</v-list-item-subtitle>
                </v-list-item-content>
                <v-list-item-action>
                  <!-- <v-avatar size="35px" class="info">{{ item.App }}</v-avatar> -->
                  <!-- <v-btn
                    icon
                    :class="fav ? 'red--text' : ''"
                    @click="fav = !fav"
                  >
                    <v-icon>favorite</v-icon>
                  </v-btn> -->
                </v-list-item-action>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn :to="'/bookview2'" @click.native="menu = false"
                >ดูทั้งหมด</v-btn
              >
              <v-spacer></v-spacer>
              <v-btn @click="menu = false">ปิด</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
        <v-btn
          text
          dark
          :key="'signin'"
          :to="'/signin'"
          v-if="!$store.getters.isAuthen"
        >
          Sign In
          <v-icon right dark>lock_open</v-icon>
        </v-btn>
        <v-btn
          class="d-sm-none d-xs-none"
          icon
          text
          dark
          :key="'signOutIcon'"
          @click="signOut"
          v-if="$store.getters.isAuthen"
        >
          <v-icon dark>mdi-location-exit</v-icon>
        </v-btn>
        <v-btn
          class="d-none d-xs-flex d-sm-flex"
          text
          dark
          :key="'signOut'"
          @click="signOut"
          v-if="$store.getters.isAuthen"
        >
          Sign Out
          <v-icon right dark>mdi-location-exit</v-icon>
        </v-btn>
        <v-list-item-avatar v-if="$store.getters.isAuthen && isMobile && false">
          <v-menu
            offset-y
            :close-on-content-click="false"
            :nudge-width="200"
            v-model="avatarMenu"
          >
            <template v-slot:activator="{ on }">
              <v-avatar size="36px" v-on="on">
                <img
                  :src="
                    apiPath +
                    'content/emp_img.asp?w=450&img=' +
                    $store.state.users.main.Description +
                    '.jpg'
                  "
                />
              </v-avatar>
            </template>
            <v-card>
              <v-list>
                <v-list-item :to="'/profile'">
                  <v-list-item-title>profile</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-card>
          </v-menu>
        </v-list-item-avatar>
      </v-app-bar>

      <v-main>
        <v-container fluid fill-height>
          <v-layout justify-center align-center>
            <router-view class="ma-0 pa-0"></router-view>
          </v-layout>
        </v-container>
      </v-main>
      <v-footer color="indigo" fixed>
        <v-spacer></v-spacer>
        <span style="font-size: 10px;" class="white--text"
          >&copy; 2022 - Ver:2.538.0<span v-if="!isMobile">
            Build:20251219.094451</span
          ></span
        >
        <v-spacer></v-spacer>
      </v-footer>
      <v-snackbar v-model="showUpdate" timeout="-1">
        [{{ version }} ==> {{ versionServer }}] - {{ textUpdate }}

        <template v-slot:action="{ attrs }">
          <v-btn
            :loading="!showUpdatebtn"
            color="red"
            text
            v-bind="attrs"
            @click="reloadPage"
          >
            Reload
          </v-btn>
        </template>
      </v-snackbar>
    </v-card>
  </div>
</template>
<script>
import bookServ from "@/store/api/services/bookService";
import itisoServ from "@/store/api/services/itisoService";
import axios from "axios";
export default {
  filter: {
    type: String,
    default: "",
  },
  empCode: {
    type: String,
    default: "",
  },

  data() {
    return {
      menuPin: false,
      version: "2.538.0",
      versionServer: "0.0.0",
      showUpdate: false,
      showUpdatebtn: true,
      textUpdate: "มีการอัพเดทเวอร์ชั่นใหม่โปรด reload หน้าจอ",
      publicPath: process.env.BASE_URL,
      env: process.env.NODE_ENV,
      apiPath: process.env.VUE_APP_API_PATH.replace(
        "//localhost",
        window.location.protocol + "//" + window.location.host.split(":")[0]
      ),
      staticPath: process.env.VUE_APP_STATIC.replace(
        "//localhost",
        window.location.protocol + "//" + window.location.host.split(":")[0]
      ),
      selectedPRvalue: false,
      selectedPR: false,
      selectedQuotation: false,
      selectedCarRoom: false,
      selectedSaraban: 0,
      menuleft: [
        { icon: "bubble_chart", title: "หนังสือเฉพาะแผนก", to: "/bookview2" },
        { icon: "forward", title: "หน้าแรก", to: "/" },
      ],
      menuCarRoom: [
        { icon: "bubble_chart", title: "การจองรถ", to: "/reserveCar/car/0" },
        { icon: "bubble_chart", title: "การจองห้อง", to: "/reserveCar/room/0" },
      ],
      menuleftQuatation: [
        {
          icon: "bubble_chart",
          title: "ใบเสนอราคาอบรม",
          to: "/tsc/arquotationhdList/Q-HD",
        },
        {
          icon: "bubble_chart",
          title: "ใบเสนอราคาธุรการ",
          to: "/tsc/arquotationhdList/Q-AD",
        },
        {
          icon: "bubble_chart",
          title: "ใบเสนอราคาการตลาด",
          to: "/tsc/arquotationhdList/Q-MK",
        },
        {
          icon: "bubble_chart",
          title: "ใบเสนอราคา(IT)",
          to: "/tsc/arquotationhdList/Q-IT",
        },
        {
          icon: "bubble_chart",
          title: "ใบเสนอราคา(งานโครงการ)",
          to: "/tsc/arquotationhdList/Q-PJ",
        },
        {
          icon: "bubble_chart",
          title: "ใบเสนอราคา(FZ)",
          to: "/tsc/arquotationhdList/EN-FZ",
        },
        {
          icon: "bubble_chart",
          title: "ใบเสนอราคา(RCEP)",
          to: "/tsc/arquotationhdList/Q-RC",
        },
        {
          icon: "bubble_chart",
          title: "ใบเสนอราคา(IB)",
          to: "/tsc/arquotationhdList/Q-IB",
        },
        {
          icon: "bubble_chart",
          title: "ใบเสนอราคา(PD)",
          to: "/tsc/arquotationhdList/Q-PD",
        },
        {
          icon: "bubble_chart",
          title: "ใบเสนอราคา(ALL)",
          to: "/tsc/arquotationhdList/25",
        },
        { icon: "forward", title: "หน้าแรก", to: "/" },
      ],
      menuPR: [
        {
          nfloat: "prMy",
          icon: "shopping_cart",
          title: "PR ขอซื้อ/ขอจ้าง",
          to: "/pr/prdochdList/default",
        },
        {
          nfloat: "prFilter",
          icon: "how_to_reg",
          title: "รอกลั่นกรอง PR ขอซื้อ/ขอจ้าง",
          to: "/pr/prdochdList/default appv2",
        },
        {
          nfloat: "prApprove",
          icon: "how_to_reg",
          title: "รออนุมัติ PR ขอซื้อ/ขอจ้าง",
          to: "/pr/prdochdList/default appv3",
        },
        {
          nfloat: "prComplete1",
          icon: "verified",
          title: "อนุมัติแล้ว PR ขอซื้อ/ขอจ้าง",
          to: "/pr/prdochdList/default complete",
        },
        // { icon: 'bubble_chart', title: 'PR รออนุมัติ', to: '/pr/prdochdList/wait' },
        // { icon: 'bubble_chart', title: 'PR แผนก', subt:'(รอดำเนินการ)', to: '/pr/prdochdList/process' },
        // { icon: 'bubble_chart', title: 'PR แผนก', subt:' (รอรับพัสดุ/บริการ)', to: '/pr/prdochdList/product' },
        // { icon: 'bubble_chart', title: 'PR แผนก', subt:' (ตรวจรับเรียบร้อย)', to: '/pr/prdochdList/complete' },
      ],
      menuPRAS: [
        {
          nfloat: "assetMy",
          icon: "event_seat",
          title: "PR ขอซื้อสินทรัพย์ถาวร",
          to: "/pr/prdochdList/asset",
        },
        {
          nfloat: "assetFilter",
          icon: "how_to_reg",
          title: "รอกลั่นกรอง PR ขอซื้อสินทรัพย์ถาวร",
          to: "/pr/prdochdList/asset appv2",
        },
        {
          nfloat: "assetApprove",
          icon: "how_to_reg",
          title: "รออนุมัติ PR ขอซื้อสินทรัพย์ถาวร",
          to: "/pr/prdochdList/asset appv3",
        },
        {
          nfloat: "assetComplete1",
          icon: "verified",
          title: "อนุมัติแล้ว PR ขอซื้อสินทรัพย์ถาวร",
          to: "/pr/prdochdList/asset complete",
        },
        // { icon: 'bubble_chart', title: 'PR รออนุมัติ', to: '/pr/prdochdList/wait' },
        // { icon: 'bubble_chart', title: 'PR แผนก', subt:'(รอดำเนินการ)', to: '/pr/prdochdList/process' },
        // { icon: 'bubble_chart', title: 'PR แผนก', subt:' (รอรับพัสดุ/บริการ)', to: '/pr/prdochdList/product' },
        // { icon: 'bubble_chart', title: 'PR แผนก', subt:' (ตรวจรับเรียบร้อย)', to: '/pr/prdochdList/complete' },
      ],
      menutop: [
        {
          text: "งานสารบรรณ",
          to: "/booklist",
        },
        {
          text: "ระบบอื่นๆ...",
          to: "/",
        },
      ],

      fav: true,
      menu: false,
      mini: true,
      avatarMenu: false,
      message: false,
      hints: true,
      File1: {},
      clipped: false,
      drawer: false,
      fixed: false,
      miniVariant: false,
      right: false,
      rightDrawer: true,
      title: "ระบบงานสารบรรณ",
      currentDate: new Date(),
      result: "",
    };
    // console.log('data1', !this.$store.state.users.Permission)
  },
  created() {
    // console.log('layout created')
    this.$store.dispatch("prloadHistory");
    this.$store.dispatch("prCurrentStatus");
    this.$store.dispatch("prUnit");
    this.$store.dispatch("prItemSpec");
    this.$store.dispatch("prConfig");
    this.$store.dispatch("budgetProjectCode");
    // this.$store.dispatch('budgetCode')
    this.$store.dispatch("tscLoadHistory");
    // this.$store.dispatch("getEmpAll");
  },
  mounted: function () {
    // console.log('isAuthen layout', this.$store.getters.isAuthen)
    // console.log('process.env.VUE_APP_ROOT_PATH', process.env.VUE_APP_ROOT_PATH)
    // console.log('$router',this.$route)
    this.checkVersion();

    this.menuPin = this.$store.getters.empConfig.menuPin;
    // setInterval(()=>{
    //   this.checkVersion()
    // }, 3000000)

    if (this.$store.getters.isAuthen) {
      this.$nextTick(function () {
        this.updateLeftMenu();
        bookServ.getNotificate(this.$store.state.users.main).then(
          (response) => {
            // console.log('setNotificate2', response.data)
            // console.log('setNotificate2 users', this.$store.state.users.prListCount.data[0])
            let prNoti = this.$store.state.users.prListCount.data[0];
            if (prNoti) {
              if (prNoti.prFilter > 0) {
                let n = prNoti.prFilter;
                let title = "ใบขอสั่งซื้อ รอกลั่นกรอง [" + n + "]";
                response.data.data.push({
                  App: "PR",
                  ID: 1,
                  EmpCode: prNoti.empCode,
                  Title: title,
                  Link: "pr/prdochdList/default appv2",
                });
              }
              if (prNoti.prApprove > 0) {
                let n = prNoti.prApprove;
                let title = "ใบขอสั่งซื้อ รออนุมัติ [" + n + "]";
                response.data.data.push({
                  App: "PR",
                  ID: 2,
                  EmpCode: prNoti.empCode,
                  Title: title,
                  Link: "pr/prdochdList/default appv3",
                });
              }
              if (prNoti.assetFilter > 0) {
                let n = prNoti.assetFilter;
                let title = "ใบขอซื้อสินทรัพย์ถาวร รอกลั่นกรอง [" + n + "]";
                response.data.data.push({
                  App: "PR",
                  ID: 3,
                  EmpCode: prNoti.empCode,
                  Title: title,
                  Link: "pr/prdochdList/asset appv2",
                });
              }
              if (prNoti.assetApprove > 0) {
                let n = prNoti.assetApprove;
                let title = "ใบขอซื้อสินทรัพย์ถาวร รออนุมัติ [" + n + "]";
                response.data.data.push({
                  App: "PR",
                  ID: 4,
                  EmpCode: prNoti.empCode,
                  Title: title,
                  Link: "pr/prdochdList/asset appv3",
                });
              }
            }
            // this.people = response.data.data
            this.$store.commit("setNotificate", response.data.data);
          },
          (error) => {
            console.log(error);
            // this.errorHandel(error.response)
            this.errorHandel(error.response);
          }
        );
      });
    }
  },
  computed: {
    rootpath() {
      return process.env.VUE_APP_ROOT_PATH;
    },
    prListCount() {
      return this.$store.getters.prListCount;
    },
    prListCountAll() {
      return (
        this.prListCount.prMy +
        this.prListCount.prFilter +
        this.prListCount.prApprove +
        this.prListCount.assetMy +
        this.prListCount.assetFilter +
        this.prListCount.assetApprove
      );
    },
    isMobile() {
      if (
        this.$vuetify.breakpoint.name === "xs"
        // || this.$vuetify.breakpoint.name === 'sm'
      ) {
        this.mini = false;
        return true;
      } else {
        this.mini = true;
        return false;
      }
    },
  },
  watch: {
    drawer() {
      // if(this.drawer) {
      //   this.mini = false
      // } else {
      //   this.mini = true
      // }
      // console.log('watch drawer begin', this.drawer)
      this.updateLeftMenu();
      // console.log('watch drawer end', this.drawer)
      // if(this.isMobile()){
      //   this.mini = !this.drawer
      // } else {
      //   }
    },
    $route(to, from) {
      this.mini = true;
      this.checkVersion();
      this.selectedSaraban = false;
      this.selectedPR = false;
      this.selectedQuotation = false;
      this.selectedCarRoom = false;

      if (this.$route.path.indexOf("pr/") > 0) {
        this.selectedPR = true;
      }
      if (
        this.$route.path.indexOf("book") > 0 ||
        this.$route.path.indexOf("numberlist") > 0 ||
        this.$route.path.indexOf("Chart") > 0
      ) {
        this.selectedSaraban = true;
      }
      // console.log('watch $route.path', ' this.selectedPR:' +this.selectedPR+ ' this.selectedSaraban' + this.selectedSaraban + ' ' )
    },
  },
  methods: {
    pinMenu() {
      this.menuPin = !this.menuPin;
      this.mini = !this.menuPin;
      let empConfig = this.$store.getters.empConfig;
      empConfig.menuPin = this.menuPin;
      this.$store.commit("setEmpConfig", empConfig);
      let payload = {
        EmpCode: this.$store.getters.empCode,
        EmpConfig: JSON.stringify(empConfig),
      };
      itisoServ.empUpdate(payload);
    },
    toggleMenu() {
      this.mini = !this.mini;
      this.drawer = !this.mini;
    },
    async reloadPage() {
      this.showUpdatebtn = false;
      localStorage.setItem("EmpAll", "");
      await this.$store.dispatch("getEmpAll");
      window.location.reload(true);
    },
    checkVersion() {
      if (!this.showUpdate) {
        axios
          .get(this.publicPath + "version.asp?t=" + Date.now())
          .then((response) => {
            this.versionServer = response.data.version;
            console.log("version", this.version + " < " + this.versionServer);
            let versionLocal = this.version.split(".");
            let versionServer = this.versionServer.split(".");
            this.versionServer =
              versionServer[0] +
              "." +
              (parseInt(versionServer[1], 10) + 1) +
              ".0";
            if (
              parseInt(versionLocal[1], 10) <
              parseInt(versionServer[1], 10) + 1
            ) {
              this.showUpdate = true;
            }
          })
          .catch((err) => {
            console.log("err:get version", err);
          });
      }
    },
    loadprHistory() {
      // this.$store.dispatch('setName',{name:'pom'})
      this.$store.dispatch("prloadHistory");
      this.$store.dispatch("prCurrentStatus");
      this.$store.dispatch("prUnit");
      this.$store.dispatch("prItemSpec");
    },
    checkPermission(permissionArray) {
      return this.$store.getters.checkPermission(permissionArray);
    },
    layoutRefresh() {
      // console.log('before getPRListCount')
      this.$store.dispatch("checkLineStatus");
      this.$store.dispatch("budgetProjectCode");
      this.$store.dispatch("budgetCode");
      this.$store.dispatch("prListCount");
      // this.$store.dispatch('getEmpAll')
      // console.log('after getPRListCount')
    },
    errorHandel(res) {
      if (res.status === 401) {
        this.$store.state.users.main = {};
        // this.$router.push('/signin')
        // router.push('/signin')
      }
      console.log(res);
    },
    updateLeftMenu() {
      // console.log('update menu Permission.length ==>', this.$store.state.users.Permission.length)
      // console.log('menu0 !this.$store.state.users.Permission ==>', !this.$store.state.users.Permission)
      // console.log('menu1 this.$store.state.users.Permission.length === 0  ==>', this.$store.state.users.Permission.length)
      // console.log('menu2 this.$store.state.users.main.Department   ==>', this.$store.state.users.main.Department)
      if (this.checkPermission(["admin", "adminbook"])) {
        // console.log('menu2', this.menuleft)

        this.menuleft = [
          {
            icon: "mdi-inbox-arrow-down",
            title: "จัดการหนังสือรับเข้า",
            to: "/booklist",
          },
          {
            icon: "mdi-eye",
            title: "หนังสือทั้งหมด(อ่านอย่างเดียว)",
            to: "/booklistshow",
          },
          { icon: "bubble_chart", title: "หนังสือเฉพาะแผนก", to: "/bookview2" },
          { icon: "business", title: "Dashboard", to: "/Chart" },
          {
            icon: "mdi-inbox-arrow-up",
            title: "ทะเบียนหนังสือส่งออก",
            to: "/numberlist",
          },
        ];
      } else {
        // console.log('menu1', this.menuleft)

        this.menuleft = [
          // { icon: 'bubble_chart', title: 'จัดการหนังสือ', to: '/booklist' },
          {
            icon: "mdi-eye",
            title: "หนังสือทั้งหมด(อ่านอย่างเดียว)",
            to: "/booklistshow",
          },
          { icon: "bubble_chart", title: "หนังสือเฉพาะแผนก", to: "/bookview2" },
          { icon: "business", title: "Dashboard", to: "/Chart" },
          {
            icon: "mdi-inbox-multiple",
            title: "ทะเบียนหนังสือส่งออก",
            to: "/numberlist",
          },
        ];
      }
    },
    navigateTo(route) {
      if (route.name === "/") {
        localStorage.setItem("EmpAll", "");
        this.$store.dispatch("getEmpAll");
        if (this.$router.currentRoute.path === "/") {
          return;
        }
      }
      this.$router.push(route.name);
    },
    signOut() {
      this.$store.dispatch("signOut");
      this.$router.push("/signin");
    },
    DelNoti(item) {
      this.menu = false;
      if (item.App.toLowerCase() === "book") {
        this.$router.push("/bookviewedit/" + item.ID);
      } else {
        this.$router.push("/" + item.Link);
      }
      bookServ.delNotificate(item).then((response) => {
        // console.log(response.data)
        if (response.data.error === "") {
          this.$store.state.users.notificate = this.$store.state.users.notificate.filter(
            function (el) {
              return el.ID !== item.ID || el.EmpCode !== item.EmpCode;
            }
          );
          // alert('Delete')
          console.log("itemNoti", item);
          if (item.App === "itiso") {
            var code = "0000" + item.ID;
            code = code.substring(code.length - 4);
            // console.log('xxx', item.App === 'itiso')
            // console.log('code', code)
            var yy = parseInt(item.insertDate.substring(0, 4), 10) + 543;
            // console.log('itemNoti -itiso', item.Link + yy + '/' + code)
            this.$router.push(item.Link + "/" + yy + "/" + code);
          }
          if (item.App === "book") {
            this.$router.push(item.Link + "edit/" + item.ID);
          }
          // this.UpStatus(item)
        }
      });
    },

    UpStatus(item) {
      if (
        item.status !== "ระหว่างดำเนินการ" &&
        item.status !== "เสร็จสมบูรณ์"
      ) {
        bookServ.UpdateStatus(item).then((response) => {
          // console.log('status', response.data)
          if (response.data.error === "") {
            // this.item.modifyCode !== this.item.empCode
            this.$router.push("/bookviewedit/" + item.ID);
          }
        });
      }
    },
    created() {
      this.$nextTick(() => {
        // $('body').css('background', '#d2d6de')
      });
    },
  },
};
</script>

<style scope>
.home {
  cursor: pointer;
}
.home:hover {
  color: #e9e;
}
a {
  text-decoration: none;
}
.v-footer {
  z-index: 99999;
  max-height: 20px;
  padding: 1px;
  font-size: 12px;
}
</style>
<style>
body:fullscreen {
  overflow: scroll !important;
}
body:-ms-fullscreen {
  overflow: scroll !important;
}
body:-webkit-full-screen {
  overflow: scroll !important;
}
body:-moz-full-screen {
  overflow: scroll !important;
}
</style>
